var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavViviendasGreen = function SvgNavViviendasGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27,
    fill: "none",
    viewBox: "0 0 28 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#19D3C5",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m10.5 25.5.03-4.11v0c.856-3.672 6.084-3.672 6.94 0v0l.03 4.11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#19D3C5",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M24.125 10.332v13.67a2 2 0 0 1-2 1.998H5.875c-1.105 0-2-.894-2-1.999V10.332M26.5 12.43l-8.572-8.632C16.076 1.933 15.151 1 14 1s-2.076.933-3.928 2.798L1.5 12.43"
  })));
};
export default SvgNavViviendasGreen;